import { LoggerProvider, BatchLogRecordProcessor } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { SeverityNumber } from '@opentelemetry/api-logs';
import { getConfig } from '../config/env-config';
import resolveCollectorUrl from './collector-url';

function formatArgs(args) {
  return args
    .map((arg) => {
      if (typeof arg === 'string') return arg;
      if (arg instanceof Error) return `${arg.message}\n${arg.stack}`;
      try {
        return JSON.stringify(arg);
      } catch (e) {
        // Circular structures are common arguments to console.error — fall back
        // rather than lose the log record.
        return String(arg);
      }
    })
    .join(' ');
}

export default function initLogging() {
  const collectorUrl = getConfig('OTEL_COLLECTOR_URL');
  if (!collectorUrl) {
    console.warn('OTEL_COLLECTOR_URL not configured — log capture disabled');
    return;
  }

  const resource = new Resource({
    [ATTR_SERVICE_NAME]: getConfig('OTEL_SERVICE_NAME') || 'tsy-installer-agreement',
  });

  const exporter = new OTLPLogExporter({
    url: `${resolveCollectorUrl(collectorUrl)}/v1/logs`,
  });

  const loggerProvider = new LoggerProvider({ resource });
  loggerProvider.addLogRecordProcessor(new BatchLogRecordProcessor(exporter));

  const logger = loggerProvider.getLogger('browser');

  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    originalError.apply(console, args);
    logger.emit({
      severityNumber: SeverityNumber.ERROR,
      severityText: 'ERROR',
      body: formatArgs(args),
    });
  };

  console.warn = (...args) => {
    originalWarn.apply(console, args);
    logger.emit({
      severityNumber: SeverityNumber.WARN,
      severityText: 'WARN',
      body: formatArgs(args),
    });
  };

  window.addEventListener('unhandledrejection', (event) => {
    logger.emit({
      severityNumber: SeverityNumber.ERROR,
      severityText: 'ERROR',
      body: `Unhandled promise rejection: ${event.reason}`,
    });
  });
}
